import axios, { AxiosResponse } from 'axios';
import { UserRole } from '../types/UserRole';
import { UserToken, SiteAuthorize, SiteAccesstoken, UserMe } from '../types/ServerRequests';
/**
 * Cette classe permet la communication entre le backend et le frontend
 * Elle assure l'envois la reception des données entre le backend et frontend
 * Elle permet la connection et la déconnection
 */
export default class LoginServices {
    static myInstance = new LoginServices();
    private userToken?: UserToken = undefined;
    // private _authToken?: AuthToken = undefined;
    private userRole?: string;
    private userId?: number;

    public static getInstance() {
        return this.myInstance;
    }

    public getUserToken() {
        if (this.userToken !== undefined) {
            return this.userToken.access_token;
        } else {
            return undefined;
        }
    }

    public getType(): string | undefined {
        return this.userRole;
    }

    public getUserId(): number | undefined {
        return this.userId;
    }

    /**
     * génère le token de connection
     * @param {string} username
     * @param {string} password
     * @returns {Promise<void>}
     */
    public login(username: string, password: string): Promise<void> {
        return (axios.post(
            process.env.REACT_APP_AUTHORIZE_URL!, {
                username: username,
                password: password
            }).then(
                (response: AxiosResponse<SiteAuthorize>) => {
                    return this.getToken(response.data.data.authorization_code);
                }
            ).then(
                () => {
                    return this.getRole();
                    // this.userRole = UserRole.ADMIN.toString();
                    // this._authToken = responses[0].data.data;
                }
            ).catch(
                (error) => {
                    return Promise.reject(error);
                }
            )
        );
    }

    /**
     * permet la déconnection
     * @returns {Promise<void>}
     */
    public logout(): Promise<void> {
        if (this.userToken !== undefined) {
            return (axios.get(
                process.env.REACT_APP_LOGOUT_URL!,
                {
                    headers: { 'X-Access-Token': this.userToken.access_token },
                }
            ).then(
                response => {
                    this.userRole = UserRole.NOT_LOGED_IN.toString();
                    this.userToken = undefined;
                    // this._authToken = undefined;
                }
            ));
        } else {
            return Promise.reject('Not logged-in'); // Should never happened
        }
    }

    /**
     * permet la confirmation de l'email
     * @param {string} token
     * @returns {Promise<void>}
     */
    public confirmEmail(token: string): Promise<void> {
        return (axios.get(
            process.env.REACT_APP_SITE_VALIDATE_URL! + '&token=' + token,
        ).then(
            response => {
                return;
            }
        ));
    }

    // =========================================================================================================
    private getToken(authorizedKey: string): Promise<void> {
        return (axios.post(
            process.env.REACT_APP_LOGIN_URL!,
            {
                authorization_code: authorizedKey,
            }
        ).then(
            (response: AxiosResponse<SiteAccesstoken>) => {
                this.userToken = response.data.data;
            }
        ).catch(
            (error) => {
                this.userToken = undefined;
                return Promise.reject(error);
            }
        ));
    }

    private getRole(): Promise<void> {
        if (this.userToken !== undefined) {
            return (axios.get(
                process.env.REACT_APP_USER_INFO_URL!,
                {
                    headers: { 'X-Access-Token': this.userToken.access_token },
                }
            ).then(
                (response: AxiosResponse<{data: UserMe}>) => {
                    this.userRole = response.data.data.user_type_id.toString();
                    this.userId = response.data.data.id;
                }
            ).catch(
                (error) => {
                    this.userRole = undefined;
                    return Promise.reject(error);
                }
            ));
        } else {
            return Promise.reject('Not logged-in'); // Should never happened
        }
    }

    private constructor() {
        /*this.userRole = UserRole.ADMIN.toString();
        this.userToken = {
            access_token: '8205cf8cecca6f81233e746709f1d767',
            expires_at: '1527467270',
        };
        this.userId = 2;*/
        this.userRole = UserRole.NOT_LOGED_IN.toString();
    }
}


// WEBPACK FOOTER //
// ./src/services/LoginServices.tsx